import { baseApi } from '@/api/core/baseApi';
import type { Schema } from '@voley/shared-types';
import type { NumberRegistration, CreateNumberRegistrationRequest } from '../types';

export const numberRegistrationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNumberRegistrations: build.query<NumberRegistration[], void>({
      query: () => ({ url: '/phone-registrations', method: 'GET' }),
      transformResponse: (resp: Schema<'TwilioRegistrationsListResponse'>) => resp.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map((r) => ({ type: 'NumberRegistration' as const, id: r.id })),
              { type: 'NumberRegistration' as const, id: 'LIST' },
            ]
          : [{ type: 'NumberRegistration' as const, id: 'LIST' }],
    }),

    createNumberRegistration: build.mutation<NumberRegistration, CreateNumberRegistrationRequest>({
      query: (req) => {
        const fd = new FormData();
        fd.set('type', req.type);
        if (req.provider) fd.set('provider', req.provider);
        if (req.phoneNumber) fd.set('phoneNumber', req.phoneNumber);
        if (req.businessName) fd.set('businessName', req.businessName);
        if (req.email) fd.set('email', req.email);
        if (req.personalPhoneNumber) fd.set('personalPhoneNumber', req.personalPhoneNumber);
        if (req.numbersToBeHosted) fd.set('numbersToBeHosted', req.numbersToBeHosted);
        if (req.numbersToBePorted) fd.set('numbersToBePorted', req.numbersToBePorted);
        if (req.ownerSignature) fd.set('ownerSignature', req.ownerSignature);
        if (req.firstName) fd.set('firstName', req.firstName);
        if (req.lastName) fd.set('lastName', req.lastName);
        if (req.serviceAddress) fd.set('serviceAddress', req.serviceAddress);
        if (req.city) fd.set('city', req.city);
        if (req.state) fd.set('state', req.state);
        if (req.postalCode) fd.set('postalCode', req.postalCode);
        if (req.billingTelephoneNumber) fd.set('billingTelephoneNumber', req.billingTelephoneNumber);
        if (req.accountNumber) fd.set('accountNumber', req.accountNumber);
        if (req.invoiceFile) fd.set('invoice', req.invoiceFile);
        if (req.loaFile) fd.set('loa', req.loaFile);

        return {
          url: '/phone-registrations',
          method: 'POST',
          body: fd,
        };
      },
      transformResponse: (resp: Schema<'TwilioRegistrationCreateResponse'>) => resp.data,
      invalidatesTags: [{ type: 'NumberRegistration', id: 'LIST' }],
    }),
  }),
});

export const { useGetNumberRegistrationsQuery, useCreateNumberRegistrationMutation } = numberRegistrationApi;
